(function ($) {
  var SwiperOneSidePadding = function () {
  };

  var settings;

  SwiperOneSidePadding.prototype = {
    $slider: '',

    set_slider: function ($object) {
      this.$slider = $object;
    },

    setPanelSize: function () {
      /*
      No half visible container for IE <=11 - opacity transition breaks on overflow:
      hidden container
      */

      var ua = window.navigator.userAgent;
      var wrapperContainer;
      var firstSlide;
      var slideWidth;
      var trident = ua.indexOf('Trident/');
      var msie = ua.indexOf('MSIE ');

      if (this.$slider.find('> .swiper-wrapper > ' + settings.swiperElementClass).length === 1 || msie > 0 || trident > 0) {
        return;
      }

      wrapperContainer = parseInt(this.$slider.css('width').replace('px', ''), 10) + settings.oneSidePadding;
      firstSlide = this.$slider.find('> .swiper-wrapper > ' + settings.swiperElementClass).removeAttr('style').get(0);

      if (typeof firstSlide !== 'undefined') {
        slideWidth = getComputedStyle(firstSlide, null)
          .getPropertyValue('width').replace('px', '') / wrapperContainer * 100;

        this.$slider.find('> .swiper-wrapper > ' + settings.swiperElementClass).each(function () {
          this.style.width = slideWidth + '%';
        });
      }
    },

    setResize: function () {
      var parent = this;
      var resizeTimer;

      $(window).on('resize orientationchange', function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function () {
          parent.setPanelSize();

          parent.$slider[0].swiper.update(true);
          parent.$slider[0].swiper.lazy.load();
        }, 250);
      });
    }
  };

  /**
   * jQuery plugin function
   * @param options
   * @returns {*}
   */
  $.fn.swiperCarouseloneSidePadding = function (options) {
    var swiperOneSidePadding;
    // default options.
    settings = $.extend({
      oneSidePadding: 0,
      swiperElementClass: '.swiper-slide'
    }, options);

    if (settings.oneSidePadding > 0) {
      // callback
      swiperOneSidePadding = new SwiperOneSidePadding();
      swiperOneSidePadding.set_slider(this);
      swiperOneSidePadding.setPanelSize();
      swiperOneSidePadding.setResize();
    }
  };
}(jQuery));
